import produce from 'immer';
import * as selectedElementsActionTypes from '../../constants/actionTypes/selectedElements';
import * as canvasBlocksActionTypes from '../../constants/actionTypes/canvasBlocks';
import * as columnItemActionTypes from '../../constants/actionTypes/columnItem';
import checkForRemoteUser from '../common/checkForRemoteUser';

const initialState = {
    local: {},
    remote: {},
};
/**
    each selectedElementData schema looks like this:
    {
        [elmIdx]: {
            'blockData': ...,
            ...
        }
    }
*/

const selectedElements = (state = initialState, action) =>
    produce(state, (draftState) => {
        switch (action.type) {
            case selectedElementsActionTypes.ADD_SELECTED_ELEMENT: {
                const { elmIdx, data, remote, currentUserSocketId } = action.payload;
                if (checkForRemoteUser(remote, currentUserSocketId)) {
                    draftState.remote[elmIdx] = { ...data, remote };
                } else {
                    draftState.local[elmIdx] = data;
                }
                break;
            }

            case selectedElementsActionTypes.REMOVE_SELECTED_ELEMENT: {
                const elmIdx = action.payload;
                delete draftState.local[elmIdx];
                break;
            }

            case canvasBlocksActionTypes.ADD_BLOCK:
            case canvasBlocksActionTypes.DUPLICATE_BLOCKS:
            case canvasBlocksActionTypes.SWITCH_LOCK_STRUCTURE:
            case columnItemActionTypes.DUPLICATE_COLUMN_ITEM:
            case columnItemActionTypes.DELETE_COLUMN_ITEM:
            case columnItemActionTypes.MOVE_COLUMN_ITEM_CONTENT_TO_ANOTHER_COLUMN:
            case columnItemActionTypes.ADD_NEW_COLUMN_ITEM:
            case columnItemActionTypes.OVERRIDE_COLUMN_ITEM:
            case selectedElementsActionTypes.REMOVE_ALL_SELECTED_ELEMENTS: {
                const { payload } = action;
                if (checkForRemoteUser(payload?.remote, payload?.currentUserSocketId)) {
                    const { socketId } = payload.remote;
                    const newRemote = Object.entries(draftState.remote).reduce((obj, [elmIdx, el]) => {
                        if (el.remote.socketId !== socketId) {
                            obj[elmIdx] = el;
                        }
                        return obj;
                    }, {});
                    draftState.remote = newRemote;
                    break;
                }
                draftState.local = {};
                break;
            }
            default:
        }
    });

export default selectedElements;
